import {
  LoadingContainer,
  Model,
  Panels,
  Bar,
  Modal,
  Select,
  NumericInput,
} from 'peach/components'
import { useParams } from 'peach/router'

import {
  useInternalLoanRefundsGet,
  useInternalLoanRefundsPost,
} from 'core/types'
import { Page } from 'core/components'

const LoanRefunds = () => {
  const { companyId, personId, loanId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
  }>()

  const {
    data: refunds,
    isLoading,
    error,
  } = useInternalLoanRefundsGet({
    companyId,
    personId,
    loanId,
  })

  const { mutateAsync: createRefund } = useInternalLoanRefundsPost({
    companyId,
    personId,
    loanId,
  })

  const initialRefund = {
    refundAmount: 0,
    atFaultParty: 'loanOwner',
    caseId: null,
  }

  return (
    <Panels
      header={
        <Bar
          right={
            <Modal
              inititialState={initialRefund}
              onSubmit={async (newRefund) => {
                await createRefund(newRefund)
              }}
              title='Create Refund'
              trigger
            >
              <NumericInput formKey='refundAmount' />
              <Select
                formKey='atFaultParty'
                options={['loanOwner', 'loanServicer', 'merchant', 'borrower']}
              />
            </Modal>
          }
          title='Refunds'
        />
      }
    >
      <LoadingContainer error={error} loading={isLoading}>
        <Page variant='full'>
          <Model.Item json={refunds} />
        </Page>
      </LoadingContainer>
    </Panels>
  )
}

export default LoanRefunds
